import { render, staticRenderFns } from "./kin.vue?vue&type=template&id=1e10bd93&"
import script from "./kin.vue?vue&type=script&lang=js&"
export * from "./kin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports